// -------------------------  Helpers  ---------------------------------

const capitalizeString = function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
}

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * @param  {function} func
 * @param  {int} wait
 * @param  {boolean} immediate
 */
const debounce = function(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    // eslint-disable-next-line no-undef
    clearTimeout(timeout);
    // eslint-disable-next-line no-undef
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

/**
 * Returns a string that's in a format appropriate for an id. No spaces and all lowercase
 * @returns  {string}
 */
const formatId = function (str) {
  return str.toLowerCase().replace(/\s/g, "-", )
};

/**
 * Returns the value of a URL parameter
 * @param {string} variable
 * @return
 */
const getURLParam = function (variable) {
  const query = window.location.search.substring(1);
  let vars = query.split("&");
  let matches = [];
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      matches.push(decodeURIComponent(pair[1]));
    }
  }
  return matches;
};

/**
 * Returns an array with unique objects based on a key property
 * @param {array} array
 * @param {string} key
 * @returns {array}
 */
const removeDuplicateObjects = function(array, key) {
  let lookup = {};
  let result = [];

  for (let i = 0; i < array.length; i++) {
    if (!lookup[array[i][key]]) {
      lookup[array[i][key]] = true;
      result.push(array[i]);
    }
  }

  return result;
}

/**
 * Sorts an array alphabetically
 * @param {array} arr
 * @returns {array}
 */
const sortAlpha = function (arr, property) {
  // Sort alphabetically
  arr.sort(function (a, b) {
    if (property && a[property]) {
      return a[property].localeCompare(b[property]);
    } else {
      return a.localeCompare(b);
    }
  });
  return arr;
}

/**
 * Toggles a data-state attribute between two values
 * @param {object} elem
 * @param {string} one
 * @param {string} two
 */
const toggleState = function(elem, one, two) {
  elem = document.querySelector(elem);
  elem.setAttribute(
    "data-state",
    elem.getAttribute("data-state") === one ? two : one
  );
};

export {
  debounce,
  formatId,
  getURLParam,
  removeDuplicateObjects,
  sortAlpha,
};



// WEBPACK FOOTER //
// ./src/helpers.js